import { sport } from '../constants/enum';
import hasFourSightStreamVariant from './fourSightHelper';

const disableElementsForFourSightStreams = (sportId, streams) => {
  if (sportId !== sport.tennis) {
    return false;
  }

  // eslint-disable-next-line max-len
  // add negation before if you want to test with real FourSight streams (currently unavailable for testing, so we test with the inverse condition)
  return hasFourSightStreamVariant(streams);
};

export default disableElementsForFourSightStreams;
